import { CSSProperties } from "react";
import { ReactComponent as ColumnsOutlinedIcon } from "statics/images/svg/icons/columns-o.svg";

export interface IProps {
  width?: string | number;
  height?: string | number;
  style?: CSSProperties;
}

const ColumnsOutlined = ({ width = "1em", height = "1em", style }: IProps) => {
  return (
    <span role="img" aria-label="columns" className="anticon" style={style}>
      <ColumnsOutlinedIcon width={width} height={height} />
    </span>
  );
};

export default ColumnsOutlined;
